import React, {FC, useRef} from 'react';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import SwiperInstance from "swiper";
import { Swiper, SwiperSlide } from 'swiper/react';
import { 
  SwiperContainer, 
  LeftButton, 
  RightButton
} from "./styles";
import 'swiper/swiper-bundle.css';
import 'swiper/css';
import 'swiper/css/navigation';
interface GenericSwiperProps {
  children: React.ReactNode;
  slidesPerView?: number;   
  spaceBetween?: number;      
  navigation?: boolean;
  //TODO: define types for the below properties with type 'any'
  options?: any;
  breakpoints?: any;
}

const GenericSwiper: FC<GenericSwiperProps> = ({
  children,
  spaceBetween = 10,
  breakpoints = {},
  navigation= true
}) => {
  const swiperRef = useRef<SwiperInstance | null>(null);
  
  return (
    <SwiperContainer>
        {navigation && (
          <LeftButton
            onClick={() => swiperRef.current?.slidePrev()}
          >
            <ArrowBackIosNewIcon sx={{ fontSize: "1rem", color: "#235cff" }}/>
          </LeftButton>
        )}

      <Swiper
        spaceBetween={spaceBetween}
        onSwiper={(swiper: any) => (swiperRef.current = swiper)}
        breakpoints={breakpoints}
        loop={true}
      >
        {React.Children.map(children, (child) => (
          <SwiperSlide>{child}</SwiperSlide>
        ))}
      </Swiper>
      {navigation && (
        <RightButton
          onClick={() => swiperRef.current?.slideNext()}
        >
          <ArrowForwardIosIcon sx={{ fontSize: "1rem", color: "#235cff" }}/>
        </RightButton>
        )
      }
    </SwiperContainer>
  );
};

export default GenericSwiper;